import { faUndo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { UserConfigModel } from '@companion-app/shared/Model/UserConfigModel.js'
import { Button } from '~/Components/Button.js'

export interface UserConfigProps {
	config: UserConfigModel

	setValue: (key: keyof UserConfigModel, value: any) => void
	resetValue: (key: keyof UserConfigModel) => void

	/** Keys that are locked by a launch-time override and cannot be edited in the UI */
	readonlyKeys: ReadonlySet<keyof UserConfigModel>
}

interface ResetButtonProps {
	userConfig: UserConfigProps
	field: keyof UserConfigModel
}

export function ResetButton({ userConfig, field }: ResetButtonProps): React.JSX.Element {
	return (
		<Button onClick={() => userConfig.resetValue(field)} title="Reset to default">
			<FontAwesomeIcon icon={faUndo} />
		</Button>
	)
}
